import ViewSVG from "@design-system/ui-icons/vanilla/View"
import { createIcon } from "../createIcon"

export const ViewIcon = createIcon(ViewSVG)
